<template>
    <b-form @submit.prevent="CalculateSimulation" novalidate>
        <div class="row cpms-row">
            <div class="col-md-6">
                <common-form></common-form>
                <!--FORM-->
                <div class="form-group row">
                    <label class="col-md-7 col-12">{{ text.chooseCare }}</label>
                    <div class="col-md-5 col-12 text-md-right text-left">
                        <select v-show="!showResults" class="form-control form-control-sm" v-model="selectedSubAct" required>
                            <option v-for="type in subactTypes" v-bind:key="type">{{type}}</option>
                        </select>
                        <p v-show="showResults">{{ selectedSubAct }}</p>
                        <b-form-invalid-feedback :state="showRequiredSubact">
                            {{ text.requiredValueValidationMessage }}
                        </b-form-invalid-feedback>
                    </div>
                </div>
                <span >
                    <div class="form-group row">
                        <label v-if="isGlasses" class="col-md-7 col-12">{{ text.glassesFramePrice }}</label>
                        <label v-if="isLens" class="col-md-7 col-12">{{ text.annualLensPrice }}</label>
                        <div v-if="isGlasses || isLens" class="col-md-5 col-12 text-md-right text-left">
                            <div v-show="!showResults" class="input-group input-group-sm mb-3">
                                <b-form-input :state="inputValidation" v-model="amount" type="number" step="0.01" class="form-control" aria-label="montant" ></b-form-input>
                                <div class="input-group-append">
                                    <span class="input-group-text">€</span>
                                </div>
                            </div>
                            <p v-show="showResults">{{ amount + " €" }}</p>
                            <b-form-invalid-feedback :state="textValidation">
                                {{ text.positiveAmountValidationMessage }}
                            </b-form-invalid-feedback>
                            <b-form-invalid-feedback :state="showRequiredAmount">
                                {{ text.requiredAmountValidationMessage }}
                            </b-form-invalid-feedback>
                        </div>
                    </div>
                </span>
            </div>
            <br>
            <br>
            <div class="separation col-md-6">
                <results :isComplexData="isGlasses"></results>
            </div>
        </div>
        <actions @resetForm="resetForm">
        </actions>
        <br>
        <mentions v-if="isLens">
            <span slot="title" v-html="text.lensMentionsTitle"></span>
            <span v-html="text.lensMentionsText"></span>
        </mentions>
        <mentions v-if="isGlasses">
            <span slot="title" v-html="text.glassesMentionsTitle"></span>
            <span v-html="text.glassesMentionsText"></span>
        </mentions>
    </b-form>
</template>

<script>
import resources from '../helpers/resources'
import validationHelper from '../helpers/validation'
import  { simulationTypes, opticalTypes, glassTypes, refundTypes } from "../helpers/types"

const opticalVue = {
    data(){
        return {
            text : resources,
            subactTypes:[opticalTypes.Glasses.value,opticalTypes.Lens.value],
            glassTypes:[glassTypes.Simple.value,glassTypes.Average.value,glassTypes.Complex.value],
            selectedSubAct:null,
            amount:null,
            showRequiredAmount:null,
            showRequiredSubact:null
        }
    },
    methods:{
        resetForm:function (){
            this.selectedLensType = null,
            this.amount = null
        },
        CalculateSimulation:function(){
            this.showRequiredAmount = null
            this.showRequiredSubact = null
            if(validationHelper.IsAmountNotEmpty(this.amount) && !validationHelper.IsNaNorNegative(this.amount) && this.selectedSubAct !== null)
                this.$store.dispatch('simulateRefund', { simulationType: simulationTypes.opticalCare.code, specificData: this.TransformAndGetData() })
            if(!validationHelper.IsAmountNotEmpty(this.amount))
                this.showRequiredAmount = false
            if (this.selectedSubAct === null)
                this.showRequiredSubact = false
        },
        TransformAndGetData:function () {
            return {
                opticalCareType:this.selectedSubAct != null ?
                    opticalTypes.getCode(this.selectedSubAct) : null,
                lensAnnualAmount:this.selectedSubAct === opticalTypes.Lens.value ? this.amount : null,
                opticalEquipmentAmount:this.selectedSubAct === opticalTypes.Glasses.value ? this.amount : null
            }
        }
    },
    computed:{
        showResults(){ return this.$store.getters.showResults },
        isLens(){
            return this.selectedSubAct === opticalTypes.Lens.value
        },
        isGlasses(){
            return this.selectedSubAct === opticalTypes.Glasses.value
        },
        textValidation() { 
            return !validationHelper.IsNaNorNegative(this.amount)
        },
        inputValidation() {
            return validationHelper.IsAPositiveAmountAndNotRequired(this.amount)
        }
    },
    beforeRouteLeave (to, from, next) {
        this.$store.dispatch('backToSimulation')
        next()
    }
}

export default opticalVue
</script>

  


// WEBPACK FOOTER //
// src/components/OpticalCare.vue